import { MccUser, MccUserDTO } from "auth"
import { Mapper } from "lib/api"
import { AddOrUpdateUserResponse } from "models/dto/user"

// first param is the DTO, second param is the class
export class MccUserMapper extends Mapper<MccUserDTO, MccUser> {
	constructor() {
		super(MccUser) // Pass the target class constructor
	}
}

export function New(): MccUserMapper {
	return new MccUserMapper()
}

export function MapBusinessUserToMcc(bu: AddOrUpdateUserResponse["businessUser"]): MccUser {
	const dto: MccUserDTO = {
		id: bu.id,
		name: bu.name,
		description: "", // added missing required field
		tcn: bu.tcn,
		createDate: "",
		updateDate: "",
		disabled: false,
		// Provide minimal placeholder entities to satisfy MinimalEntity (id, name, tcn)
		createUser: { id: "", name: "", tcn: 0 },
		updateUser: { id: "", name: "", tcn: 0 },
		contact: bu.contact as any,
		roleList: bu.roleList as any,
		userRoles: [],
		menuList: [],
		permissionList: [],
	}
	return new MccUserMapper().Map(dto)
}